// extracted by mini-css-extract-plugin
export default {"wrap":"Links_wrap__05uCY","btn":"Links_btn__uMklM"};